<div class="step-principal space-y-2" [formGroup]="formGroup">
  <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
    <div class="md:col-span-3 flex gap-2 items-end">
      <div class="flex-1">
        <label class="block mb-1 text-sm font-medium text-gray-700">Fornecedor</label>
        <p-dropdown [options]="supplierOptions" formControlName="supplierId" optionLabel="label" optionValue="value"
          placeholder="Selecione o fornecedor" [filter]="true" filterBy="label" appendTo="body" class="w-full"
          [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('supplierId')}"></p-dropdown>
        <small class="text-red-500" *ngIf="isFieldInvalid('supplierId')">Fornecedor é obrigatório</small>
      </div>
    </div>
    <div class="col-span-1 flex justify-end items-center">
      <p-button label="Cadastrar fornecedor" icon="pi pi-plus" severity="secondary" (click)="requestNewSupplier.emit()"
      class="shrink-0"></p-button>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
    <div class="md:col-span-2">
      <label class="block mb-1 text-sm font-medium text-gray-700">Chave da nota fiscal</label>
      <input pInputText formControlName="accessKey" placeholder="Chave de acesso da NF-e (44 dígitos)" class="w-full"
        [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('accessKey')}" maxlength="44" />
      <small class="text-red-500" *ngIf="isFieldInvalid('accessKey')">{{ getAccessKeyError() }}</small>
    </div>

    <div>
      <label class="block mb-1 text-sm font-medium text-gray-700">Data de emissão</label>
      <p-datePicker formControlName="emissionDate" dateFormat="dd/MM/yy" iconDisplay="input" placeholder="Data"
        appendTo="body" class="w-full" [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('emissionDate')}"></p-datePicker>
      <small class="text-red-500" *ngIf="isFieldInvalid('emissionDate')">Data é obrigatória</small>
    </div>

    <div>
      <label class="block mb-1 text-sm font-medium text-gray-700">Hora de entrada</label>
      <input pInputText formControlName="emissionTime" placeholder="Ex: 14:30" class="w-full"
        [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('emissionTime')}" />
      <small class="text-red-500" *ngIf="isFieldInvalid('emissionTime')">Hora é obrigatória</small>
    </div>
  </div>
</div>